module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'active': _vm.active
    },
    attrs: {
      "id": "contact-overlay"
    }
  }, [_c('a', {
    staticClass: "closeBtn",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeContact()
      }
    }
  }, [_c('img', {
    staticClass: "close-btn",
    attrs: {
      "src": require("../assets/times-bk.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b936cdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 438
// module chunks = 1